import { render, staticRenderFns } from "./ImportDialog.vue?vue&type=template&id=3879dd30&scoped=true"
import script from "./ImportDialog.vue?vue&type=script&lang=js"
export * from "./ImportDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportDialog.vue?vue&type=style&index=0&id=3879dd30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3879dd30",
  null
  
)

export default component.exports